<div class="space-y-4">
  <app-storage-sensor-management
    *ngIf="availableSensorTypes.includes('storage')"
  ></app-storage-sensor-management>

  <app-transport-sensor-management
    *ngIf="availableSensorTypes.includes('transport')"
  ></app-transport-sensor-management>
</div>